<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section class="row">
    <div class="col-12">
      <div v-if="replies.length === 0">No replies to show</div>
      <section v-else>
        <b-table
          class="data-table"
          :items="replies"
          :fields="headers"
          :current-page="currentPage"
          :per-page="limit">
          <template #cell(visitorName)="data">
            {{data.item.visitor.firstname}} {{data.item.visitor.lastname}}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'digital-reply-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="replies.length > limit">
            <b-pagination :total-rows="replies.length" :per-page="limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="replies.length === 0" class="col-6 ml-2 my-1">No replies to show</p>
        </b-row>
      </section>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      replies: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        currentPage: 1,
        limit: 10,
        headers: [
          { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
          { label: 'Sender', key: 'sender_name' },
          { label: 'Status', key: 'status' },
          { label: 'Updated', key: 'updated_at' },
          { label: '', key: 'actions' },
        ],
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
